<template lang="pug">
  .div
    .columns
      .column.is-12
        CardResponsiva(:responsiva="responsiva")
    .columns
      .column.is-12
        CardItems(:item="item")
</template>

<script>
  import CardResponsiva from '../components/CardResponsiva.vue'
  import CardItems from '../components/CardItems.vue'

  export default {
    name: 'DataRespItems_Comunicacion',
    components: {
      CardResponsiva,
      CardItems
    },
    props: {
      responsiva: {
        type: Object,
        default: function () {
          return {}
        }
      },
      item: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/DataRespItems_Comunicacion.vue